<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="tit01">
<h2 class="titlePageTitle">This One and Magic Life</h2>
<h2 class="titlePageAuthor">Anne Carroll George</h2>
<p class="colophon"><img alt="image" src="images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?0e5298ce